// extracted by mini-css-extract-plugin
export default {"list":"DetailedOptions_list__iwo4Y","list_item":"DetailedOptions_list_item__qH95S"};